import React from "react";
import { sculpturesDesignData } from "../../utils/sculptures";
import MobileWatch from "../../assets/mobile_watch.svg";
import "./Sculptures.css";
import { isMobile } from "../../utils/appUtils";

interface Design {
  id: number;
  name: string;
  image?: boolean;
}

const Sculptures: React.FC = () => {
  const mobile = isMobile();

  return (
    <div className={`sculptures-container ${mobile ? 'mobile' : ''}`}>
      <div className="sculpture-design-boxes">
        {sculpturesDesignData.map((design: Design) => (
          <div key={design.id} className="sculpture-box-container">
            <div 
              className="sculpture-box"
              style={{
                backgroundImage: design.image ? `url(${MobileWatch})` : 'none',
                backgroundColor: design.image ? 'transparent' : '#42424233'
              }}
            ></div>
            <p>{design.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sculptures;